import React, { Component } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import Layout from './../layouts/Index';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Container, ListGroup, Button, Placeholder } from 'react-bootstrap';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { getProduct } from './../../store/actions/ProductActions';
import './show.css';

class Show extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            currentImageIndex: 0
        };

        this.thumbnailScrollRef = React.createRef(); // Ref for scrollable thumbnail container
    }

    componentDidMount = async () => {
        const { match: { params } } = this.props;
        this.setState({ loading: true });

        const result = await this.props.getProduct(params.id);

        if (result) {
            this.setState({ loading: false });
        }
    }

    handleThumbnailClick = (index) => {
        this.setState({ currentImageIndex: index });
    };

    handlePrevClick = () => {
        const { currentImageIndex } = this.state;
        const totalImages = this.props.products.product.images.length;
        this.setState({
            currentImageIndex: currentImageIndex === 0 ? totalImages - 1 : currentImageIndex - 1
        });
    };

    handleNextClick = () => {
        const { currentImageIndex } = this.state;
        const totalImages = this.props.products.product.images.length;
        this.setState({
            currentImageIndex: currentImageIndex === totalImages - 1 ? 0 : currentImageIndex + 1
        });
    };

    scrollThumbnailsLeft = () => {
        if (this.thumbnailScrollRef.current) {
            this.thumbnailScrollRef.current.scrollBy({ left: -150, behavior: 'smooth' });
        }
    };

    scrollThumbnailsRight = () => {
        if (this.thumbnailScrollRef.current) {
            this.thumbnailScrollRef.current.scrollBy({ left: 150, behavior: 'smooth' });
        }
    };

    render() {
        const { products: { product } } = this.props;
        const { loading, currentImageIndex } = this.state;
        const placeholderBtnStyle = { height: 32, borderRadius: 6 };

        return (
            <Layout>
                <Col sm="12" style={{ minHeight: '80vh', padding: '1.5em 0' }}>
                    <Container>
                        <Row>
                            <Col 
                                sm="12"
                                className="d-flex justify-content-between align-items-center mb-3"
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", marginBottom: "1em", }}>
                                    {loading ? (
                                        <Placeholder as="h3" animation="wave">
                                            <Placeholder xs={4} />
                                        </Placeholder>
                                    ) : (
                                            <h3><strong>{product.name}</strong></h3>
                                    )}
                            </Col>
                            <Col sm="4" className="mb-3 d-flex align-items-stretch">
                                {loading ? (
                                    <Placeholder
                                        as="div"
                                        animation="wave"
                                        className="w-100 h-100"
                                        style={{ minHeight: "400px" }}
                                    >
                                        <Placeholder xs={4} className="h-100 w-100" />
                                    </Placeholder>
                                ) : (
                                    product.images && product.images.length > 0 ? (
                                        <div className="product-gallery-container">
                                            {/* Main Image with Nav Arrows */}
                                            <div className="main-image-wrapper position-relative">
                                                <LazyLoadImage
                                                    src={product.images[currentImageIndex]}
                                                    alt={product.name}
                                                    className="main-product-image"
                                                />
                                            </div>

                                            {/* Scrollable Thumbnails with Buttons */}
                                            <div className="thumbnail-scroll-wrapper position-relative mt-3">
                                                <button
                                                    className="nav-arrow left"
                                                    onClick={this.scrollThumbnailsLeft}
                                                >
                                                    <FiChevronLeft />
                                                </button>

                                                <div
                                                    className="thumbnail-gallery d-flex overflow-auto px-4 py-2"
                                                    ref={this.thumbnailScrollRef}
                                                    style={{ scrollBehavior: 'smooth' }}
                                                >
                                                    {product.images.map((image, index) => (
                                                        <LazyLoadImage
                                                            key={index}
                                                            src={image}
                                                            alt={`${product.name} ${index + 1}`}
                                                            onClick={() => this.handleThumbnailClick(index)}
                                                            className={`img-thumbnail me-2 ${index === currentImageIndex ? 'border-primary' : ''}`}
                                                            style={{
                                                                width: '100px',
                                                                height: '100px',
                                                                objectFit: 'cover',
                                                                flex: '0 0 auto',
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    ))}
                                                </div>

                                                <button
                                                    className="nav-arrow right"
                                                    onClick={this.scrollThumbnailsRight}
                                                >
                                                    <FiChevronRight />
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <Placeholder
                                            as="div"
                                            animation="wave"
                                            className="w-100 h-100"
                                            style={{ minHeight: "400px" }}
                                        >
                                            <Placeholder xs={4} className="h-100 w-100" />
                                        </Placeholder>
                                    )
                                )}
                            </Col>
                            {/* Content Column */}
                            <Col sm="8" style={{ marginBottom: '1em' }}>
                                {loading ? (
                                    <ListGroup>
                                    {[...Array(7)].map((_, idx) => (
                                        <ListGroup.Item key={idx}>
                                        <Placeholder as="p" animation="wave">
                                            <Placeholder xs={7} /> <Placeholder xs={4} />
                                        </Placeholder>
                                        </ListGroup.Item>
                                    ))}
                    
                                    {/* Placeholder buttons that match small button height */}
                                    <ListGroup.Item className="d-flex gap-2">
                                        <Placeholder.Button variant="primary" xs={3} style={placeholderBtnStyle} />
                                    </ListGroup.Item>
                                    </ListGroup>
                                ) : (
                                    <ListGroup>
                                        <ListGroup.Item>
                                            <strong>Description: </strong>
                                            <div
                                                style={{ marginTop: '10px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: product.description || ''
                                                }}
                                            />
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Category: </strong> {product.category_name}
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Colors: </strong>
                                            <div className="d-flex align-items-center">
                                                {product.readable_colors?.map((color, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        margin: '0 6px'
                                                    }}
                                                >
                                                    <div
                                                    className="color-box"
                                                    style={{
                                                        height: '30px',
                                                        width: '30px',
                                                        backgroundColor: color.value,
                                                        border: '2px solid #ccc',
                                                        borderRadius: '4px',
                                                        marginBottom: '4px'
                                                    }}
                                                    ></div>
                                                    <span style={{ fontSize: '12px', color: '#333' }}>{color.label}</span>
                                                </div>
                                                ))}
                                            </div>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Sizes: </strong>
                                            {product.readable_sizes?.map((size, i) => (
                                                <span key={i}>{size.label}, </span>
                                            ))}
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <Button
                                                className="mt-4"
                                                variant="success"
                                                size="sm"
                                                as={Link}
                                                to={`/admin/products/${product.id}/edit`}
                                            >
                                                Edit Product
                                            </Button>
                                        </ListGroup.Item>
                                    </ListGroup>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    products: state.products
});

export default connect(mapStateToProps, { getProduct })(Show);
